module.exports = __webpack_public_path__ + "static/media/5.d7118c7a.jpg";